



































































































































import { helpers, required, requiredIf, maxLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';

export default {
	name: 'MakeOfferSalary',

	setup() {
		const form = reactive({
			structure_type: null,
			min: 0,
			max: 0,
			hours_per_month: null,
			basic_min: 0,
			basic_max: 0,
			comm_min: 0,
			comm_max: 0,
			total_salary: 20000,
		});

		const errors = ref<object>(null);

		const initialData = ref(null);

		const numeric = helpers.regex(/^[0-9]*$/);

		const wage_types = reactive(['Monthly', 'Hourly', 'Commission']);

		const rules = computed(() => ({
			structure_type: {
				required: helpers.withMessage('Payment Unit is required.', required),
			},
			min: {
				required: helpers.withMessage(
					'Minimum is required.',
					requiredIf(() => {
						return !['Commission'].includes(form.structure_type);
					}),
				),
				numeric: helpers.withMessage('Minimum can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return ['Commission'].includes(form.structure_type) || value > 0;
				}),
			},
			max: {
				required: helpers.withMessage(
					'Maximum is required.',
					requiredIf(() => {
						return !['Commission'].includes(form.structure_type);
					}),
				),
				numeric: helpers.withMessage('Maximum can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return ['Commission'].includes(form.structure_type) || value > 0;
				}),
			},
			hours_per_month: {
				required: helpers.withMessage(
					'Hours per Month is required.',
					requiredIf(() => {
						return ['Hourly'].includes(form.structure_type);
					}),
				),
				numeric: helpers.withMessage('Hours per Month can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return !['Hourly'].includes(form.structure_type) || value > 0;
				}),
			},
			basic_min: {
				required: helpers.withMessage(
					'Minimum is required.',
					requiredIf(() => {
						return ['Commission'].includes(form.structure_type);
					}),
				),
				numeric: helpers.withMessage('Minimum can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return !['Commission'].includes(form.structure_type) || value > 0;
				}),
			},
			basic_max: {
				required: helpers.withMessage(
					'Maximum is required.',
					requiredIf(() => {
						return ['Commission'].includes(form.structure_type);
					}),
				),
				numeric: helpers.withMessage('Maximum can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return !['Commission'].includes(form.structure_type) || value > 0;
				}),
			},
			comm_min: {
				required: helpers.withMessage(
					'Commission Minimum is required.',
					requiredIf(() => {
						return ['Commission'].includes(form.structure_type);
					}),
				),
				numeric: helpers.withMessage('Commission Minimum can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return !['Commission'].includes(form.structure_type) || value > 0;
				}),
			},
			comm_max: {
				required: helpers.withMessage(
					'Commission Maximum is required.',
					requiredIf(() => {
						return ['Commission'].includes(form.structure_type);
					}),
				),
				numeric: helpers.withMessage('Commission Maximum can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return !['Commission'].includes(form.structure_type) || value > 0;
				}),
			},

			total_salary: {
				required: helpers.withMessage('Total Salary is required.', required),
				numeric: helpers.withMessage('Total Salary can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return value > 0;
				}),
			},
		}));

		const data = useVuelidate(rules, form);

		const edit = ref(false);

		const loading = ref(false);

		return { form, edit, loading, data, wage_types, initialData, errors };
	},
	computed: {
		wage_type_commission() {
			return ['Commission'].includes(this.form.structure_type);
		},
		wage_type_hourly() {
			return ['Hourly'].includes(this.form.structure_type);
		},

		...mapGetters('offerModule', {
			salary: 'getWageStructure',
		}),

		...mapGetters('jobs/single', {
			job: 'getSingleJob',
		}),

		wageStructure() {
			return JSON.parse(JSON.stringify(this.job?.wageStructure)) || null;
		},

		formattedData() {
			return {
				structure_type: this.jobWageStructure?.wage_type ? this.jobWageStructure?.wage_type : this.wageStructure?.wage_type || null,
				min: (this.jobWageStructure?.meta.min ?? this.wageStructure?.meta.min) || 0,
				max: this.jobWageStructure?.meta.max ? this.jobWageStructure?.meta.max : this.wageStructure?.meta.max || 0,
				hours_per_month: this.jobWageStructure?.meta.hours_per_month
					? this.jobWageStructure?.meta.hours_per_month
					: this.wageStructure?.meta.hours_per_month || null,
				basic_min: this.jobWageStructure?.meta.basic_min ? this.jobWageStructure?.meta.basic_min : this.wageStructure?.meta.basic_min || 0,
				basic_max: this.jobWageStructure?.meta.basic_max ? this.jobWageStructure?.meta.basic_max : this.wageStructure?.meta.basic_max || 0,
				comm_min: this.jobWageStructure?.meta.comm_min ? this.jobWageStructure?.meta.comm_min : this.wageStructure?.meta.comm_min || 0,
				comm_max: this.jobWageStructure?.meta.comm_max ? this.jobWageStructure?.meta.comm_max : this.wageStructure?.meta.comm_max || 0,
			};
		},

		jobWageStructure() {
			return JSON.parse(JSON.stringify(this.salary));
		},
	},

	watch: {
		'form.structure_type'(newValue, oldValue) {
			if (!this.data.$anyDirty) {
				this.message = null;
			}

			if (oldValue !== null && this.edit) {
				this.form = Object.assign(this.form, this.initialData);
			}
		},
	},

	mounted() {
		this.initialData = JSON.parse(JSON.stringify(this.form));
		delete this.initialData.structure_type;

		this.populateData();
	},

	methods: {
		submit() {
			if (this.edit) {
				this.toggleEdit();
				this.updateJobWageStructure();
			} else {
				this.updateJobWageStructure();
				this.$store.dispatch('offerModule/setCurrentStep', 3);
			}
		},
		toggleEdit() {
			this.edit = !this.edit;
		},

		cancel() {
			if (this.edit) {
				this.populateData();
				this.toggleEdit();
			} else {
				this.$emit('close');
			}
		},
		populateData() {
			this.form = Object.assign(this.form, this.formattedData);

			this.form.structure_type = this.formattedData.structure_type?.charAt(0).toUpperCase() + this.formattedData.structure_type?.slice(1);

			this.updateJobWageStructure();
		},

		updateJobWageStructure() {
			this.$store.dispatch('offerModule/updateWageStructure', {
				wage_type: this.form.structure_type,
				meta: {
					min: this.form.min,
					max: this.form.max,
					hours_per_month: this.form.hours_per_month,
					basic_min: this.form.basic_min,
					basic_max: this.form.basic_max,
					comm_min: this.form.comm_min,
					comm_max: this.form.comm_max,
				},
			});
		},
	},
};
